!function(window) {
function initOA(filterString = '', points = '' ){
	let conf = {
		frontendtype: "tour", // choose content type (tour, lodging, hut, poi, skiresort, story, offer, current condition)
		zoom: 11, // set initial zoom level
		center: [ 13.499143392521152, 46.15880487752184 ] // set initial map center - OBRNJENE KOORDINATE !!! [ Lon, Lat ]
	};
	conf.initMode = "gallery"; // map, gallery, list
	conf.fitDataBounds = true;
	conf.actionOpenType = "in-page";
	
	if(filterString != ''){
		conf.cfg = {
			what: {
				selected_init: filterString
			}
		};
		conf.cfg.sort = {
			selected_initFromDom : false, // use information out of configuration object
			selected_init_value : "distance",// initially sort by "distance"
			key2ascendant_init : { // set initial sort order for columns (see "little arrows")
				title : true,
				distance : true
			}
		};
	} else if(points != ''){
		conf.initDataPointList = points;
	}
	conf.openOOIUrl = function(data) {
		return "#ipd=" + data.id+"&pid="+data.id;
	};
	const fvp = oa.api.flexviewpage( conf );
}

const strId = $('#body-content').attr('data-strid');
if($('.oax-top-cont').length > 0){
	if(strId.startsWith('15_')){ // hiking
		//initOA('22689767');
		initOA();
	}
	/*else if(strId.startsWith('16_')){ // biking
		initOA('20777711');
	}*/
}


window.initOA = initOA;
window.strId = strId;
}(window);